import appTranslations from './locales/de-CH.json';

export default appTranslations;
